module.exports = __webpack_public_path__ + "img/ad.24daf954.svg";